module.exports = __webpack_public_path__ + "img/sudan.e32c583d.svg";